import React from 'react';
import ErrorIcon from 'react-icons/lib/md/do-not-disturb-off';

const ManifestDeleteFail = ({manifestDeleteResponse}) => {
    return (
        <div className={'text-center'}>
            <ErrorIcon size="70" color="#d50000"/>
            <h5 className="text-center mt-2">
                {manifestDeleteResponse}
            </h5>
        </div>
    );
};

export default ManifestDeleteFail;


// WEBPACK FOOTER //
// ./src/views/search/failed-manifest-delete.js